import { useQuery, ApolloError } from '@apollo/client'

import { PROJECT_ALL_ACL } from '@libs/apollo/queries'

import { QueryProjectArgs, Project } from '@types'

interface Data {
  project?: Project
}

export const useProjectAllAcl = (
  id: string,
): {
  loading: boolean
  error: ApolloError | undefined
  refetch: (id: string) => void
  data?: Data
} => {
  const { refetch, loading, error, data } = useQuery<Data, QueryProjectArgs>(PROJECT_ALL_ACL, {
    variables: {
      id,
    },
    notifyOnNetworkStatusChange: true,
  })

  const refetchData = (id: string) => {
    try {
      const variables: QueryProjectArgs = {
        id,
      }
      refetch(variables)
    } catch (error) {
      console.error(error)
    }
  }

  return { loading, error, data, refetch: refetchData }
}
